import { isNull } from "lodash";

export interface SortSequence {
  sequence?: number;
}
function sortSequence<T extends unknown>(array: T[]) {
  const index = "sequence";
  const parsedArray = array as SortSequence[];
  if (parsedArray.length === 0) return [];
  if (parsedArray[0][index] === undefined) return [];
  const sortedArray = parsedArray.sort((valueOne, valueTwo) => {
    const a = isNull(valueOne[index]);
    const b = isNull(valueTwo[index]);
    if (valueOne[index] === valueTwo[index]) return 0;
    if (a) return 1;
    if (b) return -1;
    return Number(valueOne[index]) - Number(valueTwo[index]);
  });
  return sortedArray as T[];
}
export default sortSequence;
